import { useMe } from '@hooks/getQueries';
import { Box, Typography } from '@mui/material';

export default function WelcomeBoard() {
  const { data: me } = useMe();

  return (
    <Box px={{ xs: 2, md: 3 }}>
      <Box
        mb={3}
        display={'flex'}
        flexDirection={{ xs: 'column', lg: 'row' }}
        justifyContent={'space-between'}
        gap={{ xs: 2, lg: 0 }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
      >
        <Typography variant="h5">
          Welcome on board, {me?.first_name} {me?.last_name}!
        </Typography>
      </Box>
    </Box>
  );
}
